import { render, staticRenderFns } from "./ProductNote.html?vue&type=template&id=70fe9d14&scoped=true&"
import script from "./ProductNote.js?vue&type=script&lang=js&"
export * from "./ProductNote.js?vue&type=script&lang=js&"
import style0 from "./ProductNote.scss?vue&type=style&index=0&id=70fe9d14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe9d14",
  null
  
)

export default component.exports